import { PRODUCT_TYPE } from "@utils/enums";
import { useApiOriginacao } from "../base/useApiOriginacao";

export type ProductPermission = {
  legacy_id: PRODUCT_TYPE;
  nome: string;
  id: string;
};

export type IApiV2ProductsResponse = {
  success: boolean;
  data: {
    produtos: ProductPermission[];
  };
};

export const useApiV2Products = () => {
  return useApiOriginacao<IApiV2ProductsResponse>({
    method: "GET",
    url: "/v2/produto/me",
  });
};
